import React from 'react';

const Toast = ({ message, type = 'success', onClose }) => (
    <div
        className={`fixed top-4 right-4 py-3 px-4 rounded shadow-lg text-white z-50 ${type === 'success' ? 'bg-green-500' : 'bg-red-500'
            }`}
        style={{ animation: 'fadeOut 3s forwards' }}
        onAnimationEnd={onClose}
    >
        {message}
    </div>
);

export default Toast;
